import React, { useEffect } from "react";
import { Check, Phone } from "lucide-react";

export default function LandingBessDanke() {
  useEffect(() => {
    document.title = "Danke — deine Anfrage ist eingegangen | energyleads";
    try {
      if (!sessionStorage.getItem("lp-bess-cr") && typeof window.fbq === "function") {
        window.fbq("track", "CompleteRegistration");
        sessionStorage.setItem("lp-bess-cr", "1");
      }
    } catch (e) {}
  }, []);

  return (
    <div className="flex min-h-screen flex-col bg-[#1e2532] text-white" data-testid="lp-danke">
      <header className="flex h-[68px] items-center px-6 md:px-10">
        <span className="flex items-start gap-[2px] leading-none">
          <span className="font-display text-[21px] font-bold leading-none tracking-[-0.03em]">energy</span>
          <span className="font-display text-[21px] font-bold leading-none tracking-[-0.03em] text-[#3ecf9b]">leads</span>
          <span className="mt-[1px] text-[8px] font-bold leading-none text-white/60">TM</span>
        </span>
      </header>
      <main className="flex flex-1 items-center justify-center px-6 py-16">
        <div className="max-w-[560px] text-center">
          <span className="mx-auto flex h-[64px] w-[64px] items-center justify-center rounded-full bg-[#0f9d6e]">
            <Check size={32} strokeWidth={3} className="text-white" />
          </span>
          <h1 className="mt-7 text-3xl font-bold leading-[1.2] sm:text-4xl" data-testid="lp-danke-h1">
            Danke — deine Anfrage ist eingegangen.
          </h1>
          <p className="mt-5 text-[16.5px] leading-[1.75] text-white/75">
            Wir melden uns innerhalb von 24 Stunden. Wenn es schneller gehen soll:
          </p>
          <a href="tel:+4921714013650" data-testid="lp-danke-phone" className="mt-4 inline-flex items-center gap-2.5 text-[22px] font-bold text-[#3ecf9b]">
            <Phone size={20} /> 02171 4013650
          </a>
          <p className="mt-7 text-[14px] text-white/55">Du bekommst gleich eine Bestätigung per Mail.</p>
        </div>
      </main>
      <footer className="py-8 text-center text-[13px] text-white/55">
        energyleads™ — eine Marke der ONEVOLT Energy GmbH · Borsigstraße 1 · 51381 Leverkusen ·{" "}
        <a href="/impressum/" className="underline underline-offset-2">Impressum</a> ·{" "}
        <a href="/datenschutzerklaerung/" className="underline underline-offset-2">Datenschutz</a>
      </footer>
    </div>
  );
}
